export default {
  /**
   * @param name
   * @param data
   */
  downloadCsv(name, data) {
    const link = document.createElement('a');
    const date = (new Date()).toISOString().substring(0, 19);
    link.setAttribute('href', `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURI(data)}`);
    link.setAttribute(
      'download',
      `${name}_${date}.csv`,
    );
    document.body.appendChild(link);
    link.click();
  },
};



// WEBPACK FOOTER //
// ./src/services/download-service.js